<template>
  <TableCell
    :tag
    :selectedCells
    v-model:showingPopover="showingPopover"
    v-model:columnSelectionCode="columnSelectionCode"
  >
    {{ formatDate(dateValue) }}

    <template #BinSelectionInput>
      <slot name="BinSelectionInput"></slot>
    </template>

    <template #OverlayOverride>
      <Dialog modal dismissableMask v-model:visible="showingPopover">
        <template #header>
          <div style="display: flex; align-items: center; gap: 20px;">
            <h3>
              Date / Time
            </h3>
            <slot name="BinSelectionInput"></slot>
            <div style="flex-grow: 1;"></div>
          </div>
        </template>
        <DatePicker horizontal v-model:date="newDateValue"></DatePicker>
        <div style="display: flex; flex-direction: column; gap: 10px; margin-top: 30px;">
          <Button severity="secondary" style="justify-content: center;" @click="onClickUseComputerTime()">
            Use computer time
          </Button>
          <div style="display: flex; gap: 10px;">
            <Button severity="primary" style="flex-grow: 1; flex-basis: 0; justify-content: center;" @click="onClickOk()">
              Ok
            </Button>
            <Button severity="secondary" style="flex-grow: 1; flex-basis: 0; justify-content: center;" @click="showingPopover = false">
              Cancel
            </Button>
          </div>
        </div>
      </Dialog>
    </template>
  </TableCell>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { padStart } from "./utility.js";
import { changeSettings } from "./appUtility.js";
import { dezoneDate, zoneDate } from "./timezones.js";
import TableCell from "./TableCell.vue";
import DatePicker from "./DatePicker.vue";

let props = defineProps([
  "tag",
  "selectedCells",
  "showingPopover",
  "applyToAllColumnsEnabled",
  "columnSelectionCode",
]);

let showingPopover = defineModel("showingPopover");
let columnSelectionCode = defineModel("columnSelectionCode");

let timezone = computed(() => {
  return props.tag.$session.system.timezone.value;
});

let dateValue = computed(() => {
   let date = new Date(props.tag.value * 1000);
   return zoneDate(date, timezone.value);
});

let newDateValue = ref(null);
watch(showingPopover, () => {
  newDateValue.value = new Date(dateValue.value);
});

function onClickUseComputerTime() {
  newDateValue.value = zoneDate(new Date(), timezone.value);
}

function onClickOk() {
  showingPopover.value = false;
  let date = dezoneDate(newDateValue.value, timezone.value);
  changeSettings(props.selectedCells, (cell) => [{
    handle: cell.componentArgs.tag.handle,
    value: date.getTime() / 1000
  }]);
}

function formatDate(date) {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
  let hours = date.getUTCHours();
  let hours12 = (hours) ? (hours <= 12 ? hours : hours - 12) : 12;
  let meridiem = (hours < 12) ? " AM" : " PM";
  let timePart = padStart(hours12, 2, "0") + ":" + padStart(date.getUTCMinutes(), 2, "0") + meridiem;
  let datePart = days[date.getUTCDay()] + " " + months[date.getUTCMonth()] + " " + date.getUTCDate() + ", " + date.getUTCFullYear();
  return datePart + " " + timePart;
}
</script>